import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { MspDashboardDateRangePeriod, MspDashboardDateRangeResponse } from '../../interfaces/msp-dashboard-kpi';
import { ManagedServicesSharedDataService } from '../../../services/managed-services-shared-data.service';
import { dateRangeTypes } from '../../types/dashboards';
import { environment } from 'src/environments/environment';
import { MSPDashboardV2Component } from '../msp-dashboard-v2.component';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-dashboard-date-ranges',
  templateUrl: './dashboard-date-ranges.component.html',
  styleUrls: ['./dashboard-date-ranges.component.scss'],
  standalone: false,
})
export class DashboardDateRangesComponent extends MSPDashboardV2Component implements OnChanges {
  @Input() dashboard: string;
  @Input() boards: string[] = [];

  openedDateRangeMap: Record<string, MspDashboardDateRangePeriod & { label: string }> = {};
  closedDateRangeMap: Record<string, MspDashboardDateRangePeriod & { label: string }> = {};
  dateRangeStates: Record<string, { loading: boolean; error: boolean }> = {};
  showTitles!: boolean;
  readonly dateRangeTypes = dateRangeTypes;

  constructor(
    private http: HttpClient,
    private router: Router,
    private managedServicesSharedDataService: ManagedServicesSharedDataService,
  ) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['dashboard']?.currentValue) {
      this.fetchAll();
    }
  }

  filterByDateRange(startDate: string, endDate: string, label: string) {
    this.managedServicesSharedDataService.resetFilters();
    if (label === 'Opened Tickets') {
      this.managedServicesSharedDataService.filters.createdAfter = startDate;
      this.managedServicesSharedDataService.filters.createdBefore = endDate;
    } else if (label === 'Closed Tickets') {
      this.managedServicesSharedDataService.filters.closedAfter = startDate;
      this.managedServicesSharedDataService.filters.closedBefore = endDate;
    }
    this.navigate(null);
  }

  retryFetchDateRange(type: string) {
    this.fetchDateRange(type);
  }

  private fetchAll() {
    this.openedDateRangeMap = {};
    this.closedDateRangeMap = {};
    dateRangeTypes.forEach((type) => this.fetchDateRange(type));
  }

  private fetchDateRange(type: string) {
    this.showTitles = false;
    this.dateRangeStates[type] = { loading: true, error: false };
    this.isFetchingKpis.emit(true);

    this.http
      .get<MspDashboardDateRangeResponse>(
        `${environment.restUrl}/v1/msp/dashboards/${this.dashboard}/date-range/${type}`,
      )
      .pipe(
        finalize(() => {
          this.isFetchingKpis.emit(false);
        }),
      )
      .subscribe({
        next: (range) => {
          this.showTitles = true;
          this.openedDateRangeMap[type] = { label: range.label, ...range.opened };
          this.closedDateRangeMap[type] = { label: range.label, ...range.closed };
          this.dateRangeStates[type] = { loading: false, error: false };
        },
        error: () => {
          this.dateRangeStates[type] = { loading: false, error: true };
        },
      });
  }

  private navigate(statusType: 'open' | 'closed' | null) {
    this.managedServicesSharedDataService.filters.boardNames = this.boards;
    this.managedServicesSharedDataService.filters.relationship = 'parent';
    this.managedServicesSharedDataService.filters.statusesGroup = statusType ? [statusType] : [];
    this.router.navigateByUrl(`/secured/managed-services/tickets?refresh=${Date.now()}`);
  }
}
